<div [class]="classes">
  <span>{{ errorMessage }}</span>
</div>
